
import Grid from '@mui/material/Grid';
import Reproductive from "./CancerCards/Reproductive/Reproductive";
import HeadNeck from "./CancerCards/HeadNeck/HeadNeck";
import Breast from "./CancerCards/Breast/Breast";
import Brain from "./CancerCards/Brain/Brain";
import Digestion from "./CancerCards/Digestion/Digestion";
import Urinary from "./CancerCards/Urinary/Urinary";
import Lung from "./CancerCards/Lung/Lung";
import Endocrine from "./CancerCards/Endocrine/Endocrine";
import Skin from "./CancerCards/Skin/Skin";
import Bone from "./CancerCards/Bone/Bone";
import Eye from "./CancerCards/Eye/Eye";
import Blood from "./CancerCards/Blood/Blood";
import PageProtected from "../../../components/Page/PageProtected";
import DiagroupCancer from './DiagroupCancer';



export default function CancerWelcome() {

return (
<>
<PageProtected

        headline="Cancer Signature"
        main={<>
    
                        <Grid container spacing={6} sx={{ pl: {xs: '2rem', lg: '18rem'}, pr:{xs: '1rem', lg: '12rem'} }}>

                        <DiagroupCancer />

                                <Grid item> <Breast />          </Grid>
                                <Grid item> <Reproductive />    </Grid>
                                <Grid item> <Digestion />       </Grid>
                                <Grid item> <Urinary />         </Grid>
                                <Grid item> <Brain />           </Grid>
                                <Grid item> <HeadNeck />        </Grid>
                                <Grid item> <Lung />            </Grid>
                                <Grid item> <Endocrine />       </Grid>
                                <Grid item> <Skin />            </Grid>
                                <Grid item> <Bone />            </Grid>
                                <Grid item> <Eye />             </Grid>
                                <Grid item> <Blood />           </Grid>

                      
                        
                        </Grid>
                        </>}

/>


</>
)}

